export enum EquipementProperty {
  CODE = 'CODE',
  TITLE = 'TITLE',
}
